
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';
import { GiRotaryPhone } from "react-icons/gi";
import Rating from '../rating/rating';
const arraySort = require('array-sort');

var stringUtil = require('../../utils/string/stringUtil.js');
var dateUtil = require('../../utils/dateUtil/dateUtil.js');
var commonUtility = require('../../utils/domain/commonUtility.js');
var viewUtil = require('../../utils/view/viewUtil.js');
var translator = require('../../utils/translator/translator.js');
var logger = require('../../utils/logger/logger.js');
var guidUtil = require('../../utils/guid/guidUtil.js');
var navigationButtonsIds = require('../../views/Navigation/navigationButtonsIds.js');
var stateManager = require('../../utils/state/stateManager.js');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction.js');
var saleContextUtil = require('../../views/Order/utils/saleContextUtil.js');
var userNotificationsUtil = require('../../utils/userNotifications/userNotificationsUtil.js');
var staffUtility = require('../../utils/domain/staff/staffUtility');
var staffAccessUtility = require('../../utils/domain/staff/staffAccessUtility');
var staffActivities = require('../../utils/domain/staff/staffActivities');

class CLIAlertComponent extends Component 
{

    render()
    {
        return (<table width="100%">
                    <tr>
                        <td align="center">
                            <table>
                                <tr>
                                    <td>
                                        <GiRotaryPhone size={40}/>
                                    </td>
                                    <td>
                                        <div style={{marginTop:'2px', marginLeft:'10px', fontSize:'2rem'}}>{translator.getLabel("incoming_call")}</div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <hr style={{margin:'0px', padding:'0px', marginTop:'5px', marginBottom:'10px'}}/>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {this.renderCustomer()}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                        </td>
                    </tr>

                    {this.renderLoginWarning()}

                    <tr>
                        <td align="center">
                            {this.renderToolBar()}
                        </td>
                    </tr>
                </table>);
    }

    renderCustomer()
    {
        if (this.props.cliDetails.customer == null)
        {
            return (<div style={{marginLeft:'10px', textAlign:'center', fontSize:'1.5rem'}}>
                        <div>{this.props.cliDetails.cliIncomingNumber}</div>
                        <div>{translator.getLabel("new_customer")}</div>
                    </div>)
        }

        const customer = this.props.cliDetails.customer;
        const rating = customer.profile ? customer.profile.rating : null;
        
        return (<table width="100%">
                    <tr>
                        <td style={{width:'100%'}}>
                            <div style={{marginLeft:'10px'}}>
                                <div>
                                    <div className='d-flex flex-row justify-content-center align-content-center'>
                                        <div style={{fontSize:'1.5rem'}}>{customer.name}</div>
                                        <div style={{marginLeft:'5px', marginTop:'0px'}}><Rating rating={rating}></Rating></div>
                                    </div>
                                    <div style={{textAlign:'center', fontSize:'1.5rem'}}>{customer.phoneNumber}</div>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                        </td>
                    </tr>

                    <tr>
                        <td style={{width:'100%'}}>
                            <div style={{marginLeft:'10px'}}>
                                {this.renderCustomerOrderDetails()}
                            </div>
                        </td>
                    </tr>
        </table>)
        
    }

    renderCustomerOrderDetails()
    {
        var allOrderCount = stringUtil.isStringNullOrEmpty(this.props.cliDetails.orderCount) ? 0 : this.props.cliDetails.orderCount;

        return (<div style={{textAlign:'center', fontSize:'1.2rem'}}>{translator.getLabel("no_of_past_orders")}: {allOrderCount}</div>);
    }

    renderLoginWarning()
    {
        if (staffUtility.getLoginStaff() == null)
        {
            return <Fragment>
                        <tr>
                            <td>
                                <div style={{color:'darkred', textAlign:'center', fontSize:'1.5rem'}}>
                                    {translator.getLabel("please_login_to_place_an_order")}
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                            </td>
                        </tr>
                    </Fragment>
        }

        if (!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
        {
            return <Fragment>
                        <tr>
                            <td>
                                <div style={{color:'darkred', textAlign:'center', fontSize:'1.2rem'}}>
                                    {translator.getLabel("not_sufficient_privileges_to_place_an_order")}
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                            </td>
                        </tr>
                    </Fragment>
        }

        return null;
    }

    renderToolBar()
    {
        var disabled = false;
        if (staffUtility.getLoginStaff() == null || !staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
            disabled = true;
        
        let sale = null;
        if(this.props.cliDetails.openOrders != null && this.props.cliDetails.openOrders.length > 0)
        {
            const propertyId = commonUtility.getProperty().id;
            let openOrders = this.props.cliDetails.openOrders.filter(x => x.propertyId === propertyId);
            arraySort(openOrders, "orderDate", { reverse: true });

            if (openOrders.length > 0)
            {
                sale = stateManager.getStore().getState().todaySales.find(s => stringUtil.areStringSame(s.id, openOrders[0].saleId));
                logger.warn(`Failed to find sale in todays sale as part of incoming call`);
            }
        }

        return (<table width="100%">
                    {
                        sale == null
                        ? null
                        :<tr>
                            <td style={{width:'100%'}}>
                                <div style={{marginLeft:'10px', textAlign:'center'}}>
                                    <Button color="success" size="lg" disabled={disabled} style={{marginRight:'10px'}} onClick={
                                        ()=> {
                                                logger.info(`User presses to open existing sale for incoming call: ${this.props.cliDetails.cliIncomingNumber} with order number; ${this.props.cliDetails.cliIncomingNumber}`);
                                                viewUtil.clearAlertForId(this.props.cliDetails.cliIncomingNumber);
                                                saleContextUtil.openSale(sale, true);                                            
                                             }}>
                                        {translator.getLabel("open_latest_order")} - {sale.number}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    }
                    {
                        sale == null
                        ? null
                        :
                        <tr>
                            <td>
                                <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                            </td>
                        </tr>
                    }

                    {
                        <tr>
                            <td style={{width:'100%'}}>
                                <div style={{marginLeft:'10px', textAlign:'center'}}>
                                    <Button color="success" size="lg" disabled={disabled} style={{marginRight:'10px', background:'#585858', color:'#E8E8E8', minWidth:'300px'}} onClick={
                                        ()=> {

                                                logger.info(`User presses Hold button for incoming call: ${this.props.cliDetails.cliIncomingNumber}`);
                                                viewUtil.clearAlertForId(this.props.cliDetails.cliIncomingNumber);

                                                var notification = {};
                                                notification.id = guidUtil.generateGuid();
                                                notification.creationDateTime = dateUtil.getNow();
                                                notification.expiryDateTime = dateUtil.addMinutes(notification.creationDateTime, 5);
                                                notification.type = "cli.onHold";
                                                notification.payload = this.props.cliDetails;
                                                userNotificationsUtil.addUpdateNotifications(notification);
                                                
                                            }}>
                                        {translator.getLabel("on_hold")}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    }
                    {
                        <tr>
                            <td>
                                <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                            </td>
                        </tr>
                    }

                    <tr>
                        <td style={{width:'100%', textAlign:'center'}}>
                            <div style={{marginLeft:'10px'}}>
                                <span>
                                    <Button color="warning" size="lg" disabled={disabled} style={{marginRight:'10px'}} onClick={()=>
                                        {
                                            logger.info(`User presses Collection button for incoming call: ${this.props.cliDetails.cliIncomingNumber}`);
                                            viewUtil.clearAlertForId(this.props.cliDetails.cliIncomingNumber);

                                            let navigationDialoguePayload  = {}
                                            navigationDialoguePayload.id = navigationButtonsIds.collection;
                                            navigationDialoguePayload.existingCustomer = this.props.cliDetails.customer;
                                            if (navigationDialoguePayload.existingCustomer == null)
                                            {
                                                navigationDialoguePayload.existingCustomer = {};
                                                navigationDialoguePayload.existingCustomer.id = guidUtil.generateGuid();
                                                navigationDialoguePayload.existingCustomer.phoneNumber = this.props.cliDetails.cliIncomingNumber;
                                            }
                                            navigationDialoguePayload.component = "customer";
                                            stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));

                                        }}>
                                        {translator.getLabel("collection")}
                                    </Button>
                                    

                                    <Button color="success"  size="lg" disabled={disabled} style={{marginRight:'10px'}} onClick={()=>
                                        {
                                            logger.info(`User presses Delivery button for incoming call: ${this.props.cliDetails.cliIncomingNumber}`);
                                            viewUtil.clearAlertForId(this.props.cliDetails.cliIncomingNumber);

                                            let navigationDialoguePayload  = {}
                                            navigationDialoguePayload.id = navigationButtonsIds.delivery;
                                            navigationDialoguePayload.existingCustomer = this.props.cliDetails.customer;
                                            if (navigationDialoguePayload.existingCustomer == null)
                                            {
                                                navigationDialoguePayload.existingCustomer = {};
                                                navigationDialoguePayload.existingCustomer.id = guidUtil.generateGuid();
                                                navigationDialoguePayload.existingCustomer.phoneNumber = this.props.cliDetails.cliIncomingNumber;
                                            }
                                            navigationDialoguePayload.component = "customer";
                                            stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
                                        }}>
                                        {translator.getLabel("delivery")}
                                    </Button>

                                    <Button color="danger" size="lg" disabled={disabled} onClick={()=> viewUtil.clearAlertForId(this.props.cliDetails.cliIncomingNumber)}>
                                        {translator.getLabel("cancel")}
                                    </Button>
                                </span>
                            </div>
                        </td>
                    </tr>
                    
                </table>);
        
    }
}

const mapStateToProps = state => 
{
    return { 
                staffLoginData: state.staffLoginData,
          }
}

export default connect(mapStateToProps)(CLIAlertComponent)